// /catalog — раздел управления каталогом OWNER+MANAGER (DO-3, D18 §D18-3).
//
// Cодержит tree-view товаров по категориям с filter panel, photo-manager,
// publication-toggle и slug-editor. Защищён <RequireAuth>; permission-gating
// (любая из distributor.catalog.manage-photos/publication/sku) проверяется
// внутри CatalogAdminScreen — без любой из трёх показывается warning Banner.
//
// Файл назван `catalog.tsx`, а НЕ `catalog.index.tsx`, потому что в DO-3 нет
// nested sub-routes (single page). Если потом потребуется, например, modal-
// route для photo-manager как отдельный URL — переименовать в `catalog.index`
// + добавить `<Outlet/>` в layout.

import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { CatalogAdminScreen } from '../features/catalog/CatalogAdminScreen'

export const Route = createFileRoute('/catalog')({
  component: CatalogRoute,
})

function CatalogRoute() {
  return (
    <RequireAuth>
      <CatalogAdminScreen />
    </RequireAuth>
  )
}
